export const TRACK_VIEW_PARAM = "view";

export const TrackViewType = {
  Process: "process",
  Allocation: "allocation",
  Analytics: "analytics",
} as const;

export type TrackViewType = (typeof TrackViewType)[keyof typeof TrackViewType];
